(function () {
  class MusicManager extends PIXI.Container {
    constructor() {
      super();

      this._baseID = [];
      this._baseMusic = [
        {
          sound: "bgAmbientTheme",
          volume: 1,
        },
        {
          sound: "baseTheme",
          volume: 1,
        },
      ];

      this._popupMusic = undefined;

      this._fadeBaseTimeIn = 0.5;
      this._fadeBaseTimeOut = 2;

      this._lowerVolume = 0.3;

      this._currentLevel = 0;

      messageBus.subscribe(
        "sounds:restorePreviouslyPlayingAudio",
        this.onRestorePreviouslyPlayingAudio.bind(this)
      );
    }

    onRestorePreviouslyPlayingAudio(data) {
      if (data.reason === "back from replay" && !Reflex.replayGame) {
        this._baseID = [];
        this._freeSpinsID = [];
        this._cashLinkID = [];
        this.setUpSounds();
      }
    }

    ///////////////////////////////////////////////
    setUpSounds() {
      for (var i = 0; i < this._baseMusic.length; i++) {
        this._baseID.push(soundManager.play(this._baseMusic[i].sound));
        soundManager.setVolume(0, this._baseID[i]);
      }

      this._jackPotMusic = soundManager.play("jackPotTheme");
      soundManager.setVolume(0, this._jackPotMusic);
      this._fireballMusic = soundManager.play("fireballTheme");
      soundManager.setVolume(0, this._fireballMusic);

      this.fadeLevels(0, "base");
    }

    getMaxVolume(index, listType) {
      let list;

      switch (listType) {
        case "base":
          list = this._baseMusic;
          break;
      }

      return list[index].volume;
    }

    fadeLevels(
      level,
      listType,
      fadeInTime = this._fadeBaseTimeIn,
      fadeOutTime = this._fadeBaseTimeOut
    ) {
      let list;

      switch (listType) {
        case "base":
          list = this._baseID;
          break;
      }

      let soundsToFadeOut = [];
      let soundToFadeIn = list[level];

      for (var i = 0; i < list.length; i++) {
        if (i === level) {
          continue;
        }

        soundsToFadeOut.push(list[i]);
      }

      const volume = this.getMaxVolume(level, listType);
      soundManager.fade(volume, fadeInTime, soundToFadeIn);

      for (var i = 0; i < soundsToFadeOut.length; i++) {
        soundManager.fade(0, fadeOutTime, soundsToFadeOut[i]);
      }

      this._currentLevel = level;
    }

    getMusicLevel() {
      return this._currentLevel;
    }

    increaseLevel(listType) {
      let limit;

      switch (listType) {
        case "base":
          limit = this._baseMusic.length - 1;
          break;

        case "stormLink":
          limit = this._fireballMusic.length - 1;
          break;
      }

      let newLevel = Math.min(this._currentLevel + 1, limit);

      if (this._currentLevel !== newLevel) {
        this._currentLevel = newLevel;

        this.fadeLevels(this._currentLevel, listType);
      }
    }

    fadeBaseMusicOff(time = this._fadeBaseTimeOut) {
      for (let i = 0; i < this._baseID.length; i++) {
        soundManager.fade(0, time, this._baseID[i]);
      }
    }

    setIdleMusic() {
      this._currentLevel = 0;
      this.fadeLevels(this._currentLevel, "base");
    }

    fadeOutAllMusic(time = this._fadeBaseTimeOut) {
      this.fadeBaseMusicOff(time);
      this.fadeJackPotMusicOff(time);
      this.fadeFireballMusicOff(time);
    }

    playJackpotCelebrationMusic() {
      const self = this;

      soundManager.fade(0, 0.1, this._jackPotMusic);
      soundManager.play("jpCelebrate");

      timerManager.addTimeout(3500, function () {
        soundManager.fade(1, 0.5, self._jackPotMusic);
      });
    }

    fadeInJackPotMusic(time = 0.5) {
      const self = this;
      soundManager.play("jpIntro");
      timerManager.addTimeout(5500, function () {
        soundManager.fade(1, time, self._jackPotMusic);
      });
    }

    fadeJackPotMusicOff(time = 1) {
      soundManager.fade(0, time, this._jackPotMusic);
    }

    fadeInFireballMusic(time = 0.5) {
      let self = this;
      soundManager.play("fireBallIntro");
      timerManager.addTimeout(3000, function () {
        soundManager.fade(0.65, time, self._fireballMusic);
      });
    }

    fadeFireballMusicOff(time = 1) {
      soundManager.fade(0, time, this._fireballMusic);
    }

    startCountUp() {
      soundManager.play("countUpLoop");
    }

    endCountUp() {
      soundManager.stop("countUpLoop");
      soundManager.play("countUpLoopEnd");
    }

    startBigWin() {
      soundManager.play("bigWinAnnouce");
      soundManager.play("bigWinLoop");
    }

    endBigWin() {
      soundManager.stop("bigWinLoop");
      soundManager.play("bigWinLoopEnd");
    }
  }

  ///////////////////////////////////////////////
  let musicManagerCreator = function (json) {
    return new MusicManager();
  };

  ///////////////////////////////////////////////
  let musicManagerInitialiser = function (json, obj) {};

  ///////////////////////////////////////////////
  let musicManagerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "MusicManager",
    musicManagerCreator,
    musicManagerInitialiser,
    musicManagerFilesRequired
  );
})();
